/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Destination } from './Destination';
import {
    DestinationFromJSON,
    DestinationFromJSONTyped,
    DestinationToJSON,
} from './Destination';
import type { Source } from './Source';
import {
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
} from './Source';

/**
 * 
 * @export
 * @interface SentMessage
 */
export interface SentMessage {
    /**
     * 
     * @type {boolean}
     * @memberof SentMessage
     */
    acknowledged?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SentMessage
     */
    addressed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SentMessage
     */
    color?: string;
    /**
     * 
     * @type {Destination}
     * @memberof SentMessage
     */
    destination?: Destination;
    /**
     * 
     * @type {string}
     * @memberof SentMessage
     */
    formattedTime?: string;
    /**
     * 
     * @type {string}
     * @memberof SentMessage
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SentMessage
     */
    safety?: boolean;
    /**
     * 
     * @type {Source}
     * @memberof SentMessage
     */
    source?: Source;
    /**
     * 
     * @type {string}
     * @memberof SentMessage
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof SentMessage
     */
    text?: string;
    /**
     * 
     * @type {Date}
     * @memberof SentMessage
     */
    time?: Date;
}

/**
 * Check if a given object implements the SentMessage interface.
 */
export function instanceOfSentMessage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SentMessageFromJSON(json: any): SentMessage {
    return SentMessageFromJSONTyped(json, false);
}

export function SentMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SentMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'acknowledged': !exists(json, 'acknowledged') ? undefined : json['acknowledged'],
        'addressed': !exists(json, 'addressed') ? undefined : json['addressed'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'destination': !exists(json, 'destination') ? undefined : DestinationFromJSON(json['destination']),
        'formattedTime': !exists(json, 'formatted_time') ? undefined : json['formatted_time'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'safety': !exists(json, 'safety') ? undefined : json['safety'],
        'source': !exists(json, 'source') ? undefined : SourceFromJSON(json['source']),
        'status': !exists(json, 'status') ? undefined : json['status'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'time': !exists(json, 'time') ? undefined : (new Date(json['time'])),
    };
}

export function SentMessageToJSON(value?: SentMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'acknowledged': value.acknowledged,
        'addressed': value.addressed,
        'color': value.color,
        'destination': DestinationToJSON(value.destination),
        'formatted_time': value.formattedTime,
        'id': value.id,
        'safety': value.safety,
        'source': SourceToJSON(value.source),
        'status': value.status,
        'text': value.text,
        'time': value.time === undefined ? undefined : (value.time.toISOString()),
    };
}

